<template>
    <ResourcePage v-if="article" :theme="theme">
        <template #header>
            <ResourcePageHero :document="article" />
        </template>
        <template #main>
            <SliceZone :components="components" :slices="article?.data?.slices ?? []" />
        </template>
        <template #aside>
            <div class="article-social-sharing">
                <SocialSharing />
            </div>
        </template>
    </ResourcePage>
</template>

<script lang="ts" setup>
    import {ref, inject, computed} from 'vue';
    import {SliceZone} from '@prismicio/vue';
    import type {SuccessStoryDocument} from '@prismicio-types';
    import {useRoute} from '@typed-router';
    import {useAsyncData, useWebsitePageView} from '#imports';
    import {PRISMIC_DOCUMENT} from '~/app/keys';
    import ResourcePage from '~/components/ResourcePage.vue';
    import ResourcePageHero from '~/components/ResourcePageHero.vue';
    import SocialSharing from '~/components/SocialSharing.vue';
    import usePrismicDocument from '~/composables/content/usePrismicDocument';
    import {components} from '~/slices/components';

    const {
        params: {uid},
    } = useRoute('resources-success-story-uid');
    const document = inject(PRISMIC_DOCUMENT, ref());
    const {data: article} = await useAsyncData('success-story', () => usePrismicDocument<SuccessStoryDocument>('successStory', uid as string), {
        deep: true,
    });
    document.value = article.value;

    const theme = computed(() => {
        if (article.value?.data.theme) {
            return document.value?.data.theme;
        }
        if (article.value?.data.useAlternativeHeroShapes) {
            return 'corporate';
        }
        return 'default';
    });

    useWebsitePageView('resources-center', 'success-stories');
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;

    .article-social-sharing {
        background-color: var(--joy-color-background-default);
        border: solid 1px var(--joy-color-neutral-30);
        border-radius: var(--joy-core-radius-3);
    }
</style>
